












import { defineComponent } from '@vue/composition-api';
import { benchwaveUrl }    from '@/hooks/use-benchwave-url';

export default defineComponent({
  name: 'vBenchwave',
  setup() {
    const dynamicIframeUrl = benchwaveUrl();

    return {
      dynamicIframeUrl,
    };
  },
});
